import { getRequest } from '../services/requestHandler';
import { Sleeve } from '../models';

//5537, 3 for testing
export const getSleeves = async () => {
  const url = `sleeve/getSleeves?activeOnly=true`;
  const response = await getRequest<Sleeve>('GetSleeves', url);
  return response;
};
